const primaryTheme = {
    colorPrimary: '#666666',
    colorSecondary: '#919191',
    colorTertiary: '#D0D0D0',
    colorGrayLight: '#C4C4C4',
    colorGrayMedium: '#808080',
    colorGrayDark: '#333333'
};


export default primaryTheme


// WEBPACK FOOTER //
// ./src/theme/primaryTheme.js